export const MainPath = '/';
export const QR_CODE = '/QRCodeManagement';
export const  MANAGE_GARAGE = '/manage-garage';
export const  MANAGE_GARAGE_ADD = '/manage-garage/add';
export const LOGIN_PATH = '/auth/login';
export const LABEL_MANAGER_PATH = '/label-manager';
export const ROLL_MANAGER_PATH = '/roll-manager';
